export enum StateModuleEnum {
  DISABLED = "DISABLED",
  ENABLED = "ENABLED",
}
